'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _Pager = require('./Pager');

var _Pager2 = _interopRequireDefault(_Pager);

var _ModuleReducer = require('../../components/module/ModuleReducer');

var _SetModuleCacheAction = require('../../components/module/actions/SetModuleCacheAction');

var _SetModuleCacheAction2 = _interopRequireDefault(_SetModuleCacheAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var currentPage = (0, _ModuleReducer.getModuleCache)(state.module, [ownProps.id, 'pager', 'currentPage']) || 1;
  var totalPages = (0, _ModuleReducer.getModuleCache)(state.module, [ownProps.id, 'pager', 'totalPages']);

  return {
    currentPage: currentPage,
    totalPages: totalPages
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onPageChangeClick: function onPageChangeClick(page) {
      dispatch((0, _SetModuleCacheAction2.default)([ownProps.id, 'pager', 'currentPage'], page));
      ownProps.onPageChange();
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Pager2.default);


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/pager/PagerContainer.js
// module id = 754
// module chunks = 10